/** The hosts this user has saved from, for the library's Source filter. */
import { useQuery } from "@tanstack/react-query";
import { getNookClient } from "../client.js";
import { queryKeys } from "../query-keys.js";
export function useNookSites() {
    return useQuery({
        queryKey: queryKeys.nooks.sites(),
        queryFn: () => getNookClient().listNookSites(),
    });
}
//# sourceMappingURL=use-nook-sites.js.map